var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-img',{attrs:{"aspect-ratio":16 / 9,"src":_vm.pjImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }